import { render, staticRenderFns } from "./TreatyCessionNormalisation.vue?vue&type=template&id=7b4d4f1a&"
import script from "./TreatyCessionNormalisation.vue?vue&type=script&lang=js&"
export * from "./TreatyCessionNormalisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports